import { type NextBestAction } from '@post-office/confluence-next-best-action';
import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';

type PostOfficeSideNavMessageContextType = {
	enabledMessages: NextBestAction[];
	enablePostOfficeSideNavMessage: (message: NextBestAction) => void;
};

const PostOfficeSideNavMessageContext = createContext<PostOfficeSideNavMessageContextType | null>(
	null,
);

export const usePostOfficeSideNavMessages = () => {
	return useContext(PostOfficeSideNavMessageContext);
};

type PostOfficeSideNavMessageProviderProps = {
	children: React.ReactNode;
};

export const PostOfficeSideNavMessageProvider = ({
	children,
}: PostOfficeSideNavMessageProviderProps) => {
	const [enabledMessages, setEnabledMessages] = useState<NextBestAction[]>([]);

	const enablePostOfficeSideNavMessage = useCallback((message: NextBestAction) => {
		setEnabledMessages((prev) => {
			if (prev.includes(message)) {
				return prev;
			}
			return [...prev, message];
		});
	}, []);

	const value = useMemo(
		() => ({
			enabledMessages,
			enablePostOfficeSideNavMessage,
		}),
		[enabledMessages, enablePostOfficeSideNavMessage],
	);

	return (
		<PostOfficeSideNavMessageContext.Provider value={value}>
			{children}
		</PostOfficeSideNavMessageContext.Provider>
	);
};
